<div class="awareness-posters">
  <div class="awareness-posters__container">
    <div class="awareness-posters__intro">
      <h1 l10nTranslate>Awareness Kit</h1>
      <div class="awareness-posters__edition" l10nTranslate>October 2026</div>
      <p l10nTranslate>Download 8 free cybersecurity awareness posters and share with your employees.</p>
    </div>

    <div class="awareness-posters__card">
      <form *ngIf="!downloaded" [formGroup]="leadForm" (ngSubmit)="onSubmit()" novalidate>
        <input class="awareness-posters__honeypot" type="text" formControlName="website" tabindex="-1" autocomplete="off" aria-hidden="true" />

        <div class="awareness-posters__field" [class.invalid]="isInvalid('name')">
          <label for="name" l10nTranslate>Name</label>
          <input id="name" type="text" formControlName="name" autocomplete="name" />
          <small *ngIf="isInvalid('name')" l10nTranslate>This field is required</small>
        </div>

        <div class="awareness-posters__field" [class.invalid]="isInvalid('businessEmail')">
          <label for="businessEmail" l10nTranslate>Business Email</label>
          <input id="businessEmail" type="email" dir="ltr" formControlName="businessEmail" autocomplete="email" />
          <small *ngIf="isInvalid('businessEmail') && hasError('businessEmail', 'required')" l10nTranslate>This field is required</small>
          <small *ngIf="isInvalid('businessEmail') && hasError('businessEmail', 'email')" l10nTranslate>Please enter a valid email</small>
          <small *ngIf="isInvalid('businessEmail') && hasError('businessEmail', 'freeEmail')" l10nTranslate>Please use your business email</small>
        </div>

        <div class="awareness-posters__field" [class.invalid]="isInvalid('mobileNumber')">
          <label for="mobileNumber" l10nTranslate>Mobile Number (Optional)</label>
          <input id="mobileNumber" type="tel" dir="ltr" formControlName="mobileNumber" autocomplete="tel" placeholder="+966 5X XXX XXXX" />
          <small *ngIf="isInvalid('mobileNumber')" l10nTranslate>Please enter a valid mobile number</small>
        </div>

        <div class="awareness-posters__field" [class.invalid]="isInvalid('country')">
          <label for="country" l10nTranslate>Country</label>
          <select id="country" formControlName="country">
            <option value="" disabled l10nTranslate>Select country</option>
            <option *ngFor="let country of countries" [value]="country.code">{{ country.name }}</option>
          </select>
          <small *ngIf="isInvalid('country')" l10nTranslate>This field is required</small>
        </div>

        <label class="awareness-posters__field awareness-posters__option awareness-posters__demo">
          <input type="checkbox" formControlName="interestedInDemo" />
          <span l10nTranslate>I am interested in getting a demo of the Awareness 10 platform</span>
        </label>


        <fieldset class="awareness-posters__field" [class.invalid]="isInvalid('posterLanguage')">
          <legend l10nTranslate>Posters Language</legend>
          <div class="awareness-posters__options">
            <label class="awareness-posters__option">
              <input type="radio" formControlName="posterLanguage" value="english" />
              <span l10nTranslate>Poster Language English</span>
            </label>
            <label class="awareness-posters__option">
              <input type="radio" formControlName="posterLanguage" value="arabic" />
              <span l10nTranslate>Poster Language Arabic</span>
            </label>
            <label class="awareness-posters__option">
              <input type="radio" formControlName="posterLanguage" value="both" />
              <span l10nTranslate>Poster Language Both</span>
            </label>
          </div>
          <small *ngIf="isInvalid('posterLanguage')" l10nTranslate>Please select an option</small>
        </fieldset>

        <button class="awareness-posters__btn" type="submit" [disabled]="isSubmitting" l10nTranslate>Download Posters</button>
      </form>

      <div class="awareness-posters__success" *ngIf="downloaded">
        <img src="../../../../assets/images/tickcircle2.png" alt="" />
        <h2 l10nTranslate>Thank you!</h2>
        <p l10nTranslate>Your download should start automatically If it does not</p>
        <a [href]="bundleUrl" [attr.download]="bundleFileName" l10nTranslate>click here to download</a>
      </div>
    </div>
  </div>
</div>
